// Creates a modal for uploading new audio files

class AudioModal extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    this.innerHTML = "Loading...";
    let domain_id = this.dataset.domain_id || document.querySelector("#object_id").value;

    this.innerHTML = 
      `<div class="modal fade bd-example-modal-sm" id="ctAudioModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Manage <span id="audio-type-title"></span> Audio</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <ul class="nav nav-tabs" role="tablist" id='ct_audio_tabs' style="margin-top:0px;">
                  <li class="active"><a href="#ct_list_tab" role="tab" data-toggle="tab">List Audio</a></li>
                  <li><a href="#ct_upload_tab" role="tab" data-toggle="tab">Upload Audio</a></li>
                </ul>
                <div class="panel-body tab-content">
                  <div class="tab-pane active" id="ct_list_tab">
                    <table id="ct_audio" class="table vertical-middle" style="width:100%">
                      <thead>
                        <tr><th>Description</th><th>Play</th><th>In Use</th><th></th></tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                  <div class="tab-pane" id="ct_upload_tab" style="position: relative;">
                    <div class="errors"></div>
                    <div class="form-group" style="clear:both;">
                      <label>Description</label>
                      <input id="ct_audio_description" type="text" class="form-control" placeholder="Audio description">
                    </div>
                    <div class="form-group">
                      <select name="upload-file" class="form-control">
                        <option value=1 checked>Upload File</option>
                        <option value=0 checked>Text to Speech</option>
                      </select>
                    </div>
                    <div id="file_upload_section" class="form-group">
                      <label for=prompt>Audio Prompt</label>
                      <div class="input-group">
                        <span class="input-group-btn">
                            <span class="btn btn-primary btn-file" style="line-height: 24px;">
                                Browse&hellip; <input type="file" id=ct_audio_file name=prompt accept=".ogg,.wav" single/>
                            </span>
                        </span>
                        <input type="text" id=ct_audio_file_text class="form-control" readonly>
                      </div>
                    </div>
                    <div id="text_to_speech_section" class="form-group hidden">
                      <div class="form-group">
                        <label>Audio Prompt</label>
                        <textarea id="tts" class="form-control" placeholder="Enter the text you want to convert to audio" maxlength="1000"></textarea>
                      </div>
                      <div class="form-group">
                        <label>Language</label>
                        <select id="tts_voice" class="form-control">
                          <option value="Joanna">English Female</option>
                          <option value="Matthew">English Male</option>
                          <option value="Gabrielle">French Female</option>
                          <option value="Lupe">Spanish Female</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group" style="overflow:auto;">
                      <a id=ct_audio_save type=submit value='Save' class='btn btn-primary pull-right'>Save</a><a id=ct_audio_cancel class='btn btn-outline-secondary pull-right'>Cancel</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;

    this.querySelector("#ct_audio_save").addEventListener("click", function (e) {
      e.preventDefault();
      this.saveAudioFile();
    }.bind(this));

    this.querySelector("#ct_audio_cancel").addEventListener("click", function(e) {
      e.preventDefault();
      this.clearForm();
      this.querySelector(".close").click()
    }.bind(this));

    this.querySelector("select[name=upload-file]").addEventListener("change", (e) => {
      if(e.target.value == 1) {
        this.querySelector("#file_upload_section").classList.remove("hidden");
        this.querySelector("#text_to_speech_section").classList.add("hidden");
      } else {
        this.querySelector("#file_upload_section").classList.add("hidden");
        this.querySelector("#text_to_speech_section").classList.remove("hidden");
      }
    });

    //Shows file name of audio file to be uploaded
    $("#ctAudioModal").on('change', '.btn-file :file', function() {
      var input = $(this),
      numFiles = input.get(0).files ? input.get(0).files.length : 1,
      label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
      input.trigger('fileselect', [numFiles, label]);
    });
    
    $("#ctAudioModal").on('fileselect', '.btn-file :file', function(event, numFiles, label) {
      
      var input = $(this).parents('.input-group').find(':text'),
      log = numFiles > 1 ? numFiles + ' files selected' : label;
      
      if( input.length ) {
        input.val(log);
      } else {
        if( log ) alert(log);
      }     
    });

    // Sets the title and type of audio file to be listed/uploaded upon modal open
    $("body").on("click", ".ct_manage_audio", async function(e) {
      e.preventDefault();
      let audioType = this.getAttribute("data-audio-type-id")
      document.querySelector("audio-modal").setAudioType(audioType);
      document.querySelector("#audio-type-title").innerHTML = audioType == 0 ? "Unclassified" :
                                                              audioType == 1 ? "IVR" :
                                                              audioType == 2 ? "Generic" :
                                                              audioType == 3 ? "Disclaimer" :
                                                              audioType == 4 ? "Whisper" :
                                                              audioType == 5 ? "CallShield IVR" :
                                                              audioType == 6 ? "Voicemail" : null;
      $("#ctAudioModal").modal("show");
    });

    

    this.init();
  }

  init() {
    let domain_id = this.dataset.domain_id || document.querySelector("#object_id").value;
    this.table = $('#ct_audio').DataTable({
      "ajax": "/admin/domains/"+domain_id+"/target_audio",
      "pageLength": 8,
      "columns": [
        { "data": "audio_desc" },
        {
          data: "audio_url",
          "render": function(data, type, row) {
            return `<audio-player src="${data}"></audio-player>`;
          },
          "class": "text-center",
          "orderable": false
        },
        {
          data: "target_audio_type.name",
          "class": "text-center",
          "visible": false
        },
        {
          data: "is_used",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? '<span class="fa '+((data==true) ? "fa-check":"fa-times")+'"></span>' : data
          },
          "class": "text-center"
        },
      ],
      "order": [[0, 'asc']]
    });

    this.table.on('draw', function () {
      soundManager.reboot();
    });

    soundManager.setup({
      url: '/assets/swf/'
    });
  }

  clearForm() {
    this.querySelector("#ctAudioModal .errors").innerHTML = "";
    this.querySelector("#ct_audio_description").value = null;
    this.querySelector("#tts").value = ""
    this.querySelector("#ct_audio_file").value = null;
    this.querySelector("#ct_audio_file_text").value = null;
    this.querySelectorAll(".error").forEach((elem) => {
      elem.classList.remove("error");
    });
    this.querySelector("#ct_audio_tabs a").click();
  }

  async saveAudioFile() {
    this.querySelector("#ctAudioModal .errors").innerHTML = "";
    this.querySelectorAll(".error").forEach((elem) => {
      elem.classList.remove("error");
    });

    let uploadFile = this.querySelector("select[name=upload-file]").value;

    if(this.querySelector("#ct_audio_description").value.length == 0) {
      this.querySelector("#ct_audio_description").value.length == 0 ? this.querySelector("#ct_audio_description").classList.add("error") : null;
      this.querySelector("#ctAudioModal .errors").innerHTML=`<div class="alert alert-danger alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <strong>Warning!</strong> Please provide a description.
      </div>`;
      return;
    }

    if(uploadFile == "1") {
      //Throws error is user hasn't entered a description or chosen a file
      if(this.querySelector("#ct_audio_file").files.length == 0) {
        this.querySelector("#ct_audio_file").files.length == 0 ? this.querySelector("#ct_audio_file_text").classList.add("error") : null;
        this.querySelector("#ctAudioModal .errors").innerHTML=`<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please provide an audio file.
        </div>`;
        return;
      }
    } else {
      if(this.querySelector("#tts").value.length == 0) {
        this.querySelector("#tts").classList.add("error")
        this.querySelector("#ctAudioModal .errors").innerHTML=`<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please provide text you want converted to speech.
        </div>`;
        return;
      }
    }

    panel_refresh($('#ctAudioModal'));
    const formData = new FormData()

    formData.append('upload_file', uploadFile)
    if(uploadFile == 1) {
      formData.append('audio_file', this.querySelector("#ct_audio_file").files[0])
    } else {
      formData.append('tts', this.querySelector("#tts").value)
      formData.append('tts_voice', this.querySelector("#tts_voice").value)
    }
    formData.append('audio_description', this.querySelector("#ct_audio_description").value)
    formData.append('target_audio_type_id', this.audio_type_id)
    
    let domain_id = this.dataset.domain_id || document.querySelector("#object_id").value;
    formData.append('domain_id', domain_id)
    
    let res = await fetch('/admin/target_audio', {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
      method: 'POST',
      body: formData
    });
    let json = await res.json();
    if(json.error != null) {
      this.querySelector("#ctAudioModal .errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <strong>Warning!</strong> Unable to upload this audio file. Please try a different format.
      </div>`
      panel_refresh($('#ctAudioModal'));
    } else {
      this.reloadData();
      panel_refresh($('#ctAudioModal'));
      this.clearForm();
    }
  }

  async reloadData() {
    let domain_id = this.dataset.domain_id || document.querySelector("#object_id").value;
    let data_binder = new DataBinder("/admin/domains/"+domain_id+"/target_audio/target_audio_type/"+this.audio_type_id, true);
    await data_binder.fetchData();
    this.table.ajax.reload();
  }

  // Filters the audio type based on call treatment being created
  setAudioType(audioType) {
    this.audio_type_id = audioType;
    let audioTypeIDText;
    switch(audioType) {
      case "0":
        audioTypeIDText = "Unclassified"
        break
      case "1":
        audioTypeIDText = "IVR Audio";
        break;
      case "2":
        audioTypeIDText = "Generic Audio";
        break
      case "3":
        audioTypeIDText = "Disclaimer Audio"
        break
      case "4":
        audioTypeIDText = "Whisper Audio"
        break
      case "5":
        audioTypeIDText = "CallShield Audio"
        break
      case "6":
        audioTypeIDText = "Voicemail Audio"
        break
      case undefined:
        audioTypeIDText = ""
        break
    };
    let table = $('#ct_audio').DataTable();
    var column = table.column(2);
    var val = $.fn.dataTable.util.escapeRegex(audioTypeIDText);
    column
        .search( val ? '^'+val+'$' : '', true, false )
        .draw();
  }
}

customElements.define("audio-modal", AudioModal)